import React from 'react'

import { AlertTriangle } from 'lucide-react'

import { Button } from '../Button'
import { Modal } from '../Modal'

export interface ConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  message: string
  confirmText?: string
  cancelText?: string
  isDangerous?: boolean
  isLoading?: boolean
  variant?: 'default' | 'warning' // Para diferenciar entre advertencias y confirmaciones peligrosas
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  isDangerous = false,
  isLoading = false,
  variant = 'default'
}) => {
  const handleConfirm = () => {
    onConfirm()
  }

  const renderIcon = () => {
    if (variant === 'warning') {
      return (
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 mb-4">
          <AlertTriangle className="h-6 w-6 text-amber-600" aria-hidden="true" />
        </div>
      )
    }

    if (isDangerous) {
      return (
        <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-100 mb-4">
          <AlertTriangle className="h-6 w-6 text-red-600" aria-hidden="true" />
        </div>
      )
    }

    return null
  }

  const isWarningLayout = variant === 'warning'

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <div className={isWarningLayout ? '' : 'text-center'}>
        {isWarningLayout ? (
          <div className="flex items-start space-x-3 mb-6">
            <AlertTriangle className="h-6 w-6 text-amber-500 flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
              <p className="text-sm text-gray-600">{message}</p>
            </div>
          </div>
        ) : (
          <>
            {renderIcon()}
            <h3 className="text-lg font-semibold text-gray-900 mb-2">{title}</h3>
            <p className="text-sm text-gray-500 mb-6">{message}</p>
          </>
        )}

        <div
          className={`flex space-x-3 ${isWarningLayout ? 'justify-end pt-4' : 'justify-center'}`}
        >
          {cancelText && (
            <Button variant="secondary" onClick={onClose} disabled={isLoading}>
              {cancelText}
            </Button>
          )}
          <Button
            variant={isDangerous ? 'danger' : 'primary'}
            onClick={handleConfirm}
            isLoading={isLoading}
            disabled={isLoading}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
